// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__kHd4j","tooltipText":"tooltip_tooltipText__tvkNJ"};